import { Fragment } from 'react';

import UnitLessonCardList from '@/components/lesson/UnitLessonCardList';
import UnitLessonCard from '@/components/lesson/UnitLessonCard';
import { UnitOverviewCard } from '@/components/unit/UnitOverviewCard';
import useLessonNameFormatter from '@/data/hook/lesson/useLessonNameFormatter';
import useStaffUnitLessons from '@/data/hook/lesson/useStaffUnitLessons';
import { toStaffLessonItems } from '@/utils/lesson/lessonItems';
import { CourseRoute } from '@/utils/routes';

type StaffUnitLessonsProps = CourseRoute & {
  unitId: number;
};

export default function StaffUnitLessons({
  unitId,
  slug,
  klassId,
}: StaffUnitLessonsProps) {
  const {
    entries,
    totalLessons,
    isInitialLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useStaffUnitLessons({ unitId, slug, klassId });
  const { formatName, isLoading: isLoadingCourse } = useLessonNameFormatter();

  return (
    <Fragment>
      <UnitOverviewCard.LessonsHeader total={totalLessons} />
      <UnitLessonCardList
        isLoading={isInitialLoading || isLoadingCourse}
        isEmpty={!entries.length}
        hasError={!!error}
        onRetry={() => refetch()}
        onReachEnd={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      >
        {entries.map(({ id, lesson, scheduledLesson }) => (
          <UnitLessonCard
            key={id}
            lesson={lesson}
            name={formatName(lesson, scheduledLesson)}
            items={toStaffLessonItems(lesson)}
            slug={slug}
            klassId={klassId}
          />
        ))}
      </UnitLessonCardList>
    </Fragment>
  );
}
